import axios from 'axios'

export default async function sendToKadam(id: number) {
  const { data } = await axios.post(`/api/v1/article/kadam/${id}/`, null, {
    useRetry: false,
  })

  return data
}
